import { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';
import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';

import { MailingAddressForm } from './MailingAddressForm';
import { MailingAddressView } from './MailingAddressView';

export const AccountHolderMailingAddressSection = () => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  const isMailingAddressAlreadySaved = () => !isEmpty(account?.primaryAccountHolder?.mailingAddress);

  useEffect(() => {
    if (isMailingAddressAlreadySaved()) {
      setIsEditable(true);
    }
  }, [account?.primaryAccountHolder?.mailingAddress]);

  return (
    <MFormSection
      title='Mailing Address'
      onEdit={onEdit}
      disabled={Boolean(account?.lastFailedLinkAttemptError)}
      isEditable={isEditable}
      isEditMode={isEditMode}
      testId={'mailing-address'}>
      {isMailingAddressAlreadySaved() && !isEditMode ? (
        <MailingAddressView
          isPrimary
          type={account?.type}
          accountHolder={account?.primaryAccountHolder}
          testId={'primary'}
        />
      ) : (
        <MailingAddressForm
          accountHolder={account?.primaryAccountHolder}
          accountUuid={account?.id}
          isPrimary
          onCancel={onCancel}
        />
      )}
    </MFormSection>
  );
};
